/**
 * Algunos registros antiguos guardan el campo "variables" con saltos de línea
 * u otros caracteres de control sin escapar dentro de los strings del JSON
 * (ej. direcciones capturadas en un textarea). Eso es JSON inválido y
 * JSON.parse falla con "Bad control character in string literal".
 * Este helper reintenta el parseo escapando esos caracteres antes de fallar.
 */
const CONTROL_CHAR_PATTERN = new RegExp("[\\x00-\\x1F]", "g");

export function safeJsonParse(str, fallback = {}) {
  if (typeof str !== "string" || !str) return fallback;
  try {
    return JSON.parse(str);
  } catch (e) {
    try {
      const sanitizado = str.replace(CONTROL_CHAR_PATTERN, (ch) => {
        switch (ch) {
          case "\n": return "\\n";
          case "\r": return "\\r";
          case "\t": return "\\t";
          case "\b": return "\\b";
          case "\f": return "\\f";
          default: return "\\u" + ch.charCodeAt(0).toString(16).padStart(4, "0");
        }
      });
      return JSON.parse(sanitizado);
    } catch (e2) {
      console.log("Error parsing variables:", e2);
      return fallback;
    }
  }
}

/**
 * Antes de enviar "variables" al back, quita caracteres de control
 * (saltos de línea, tabs, etc.) de cada valor string. El back rechaza
 * esos caracteres como "caracteres especiales" y suelen llegar por un
 * copy/paste de texto multilínea en un campo de una sola línea.
 */
export function sanitizeVariables(valor) {
  if (typeof valor === "string") {
    return valor.replace(CONTROL_CHAR_PATTERN, " ").trim();
  }
  if (Array.isArray(valor)) {
    return valor.map(sanitizeVariables);
  }
  if (valor && typeof valor === "object") {
    const limpio = {};
    for (const llave of Object.keys(valor)) {
      limpio[llave] = sanitizeVariables(valor[llave]);
    }
    return limpio;
  }
  return valor;
}
